import React, { useState } from "react";
import Cookies from "js-cookie";
import AuthenticationContext, {
  UserInformation,
  // @ts-ignore
} from "./AuthenticationContext.ts";
import { useEffect, useContext } from "react";
import toast from "react-hot-toast";

import sendRequest from "../hooks/useAxios";
// admin access level: [5, 7, 8, 9, 10, 11, 12]
// customer access level : [13,14,15,16]
export default function Authentication({
  children,
}: {
  children: JSX.Element;
}) {
  const [userInfo, setUserInfo] = useState<UserInformation>({
    token: "",
    name: "",
    mobile: 0,
    email: "",
    type: [],
    id: null,
  });

  const [isLogged, setIsLogged] = useState<boolean>(false);

  useEffect(() => {
    checkCookie();
  }, []);

  function login(
    token: string,
    name: string,
    mobile: number,
    email: string,
    type: number,
    id: any
  ): void {
    if (token) {
      // if (userType == 1) {
      //   accessLevel = [13, 14, 15, 16];
      // }
      setUserInfo({
        token,
        name,
        mobile,
        email,
        type,
        id: id,
      });

      setIsLogged(true);
      Cookies.set("usertoken", token);
    }
  }

  function logout(): void {
    setUserInfo({
      token: "",
      name: "",
      mobile: 0,
      email: "",
      type: 0,
      id: null,
    });
    setIsLogged(false);
    Cookies.remove("usertoken");
  }

  function checkCookie(): void {
    if (Cookies.get("usertoken")) {
      sendRequest("audio/checklogininfo").then(({ data }) => {
        if (+data.status === 1) {
          login(
            data.token,
            data.result.name,
            data.result.mobile,
            data.result.email,
            data.result.type,
            data.result.id
          );
        } else {
          toast.error("کاربری با این مشخصات یافت نشد.");
          Cookies.remove("token");
        }
      });
    } else {
      setUserInfo({
        token: "",
        name: "",
        mobile: 0,
        email: "",
        type: 0,
        id: null,
      });
    }
  }

  return (
    <AuthenticationContext.Provider
      value={{
        login,
        userInfo,
        isLogged,
        logout,
      }}
    >
      {children}
    </AuthenticationContext.Provider>
  );
}
